const btnFilterManagementEquip = {
  label: 'filtros',
  Typography: 'Nenhum resultado encontrado'
};

export default btnFilterManagementEquip;
